import { GET_AVAILABLE_DATA_FEEDS } from '../../../../../store/actionTypes';

/**
 * Action Creator to get Available Feed Data
 * @param data
 * @returns
 */
export const getAvailableFeedData = (data: any) => ({
  type: GET_AVAILABLE_DATA_FEEDS,
  params: data,
});
